import { render, staticRenderFns } from "./ModalHistoricoTombamentoList.vue?vue&type=template&id=03948f9c"
import script from "./ModalHistoricoTombamentoList.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoTombamentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports